<cv-challenges-list [isCxone]="isCxone"></cv-challenges-list>